import ChairLamp from '../../src/legacy/ChairLamp.tsx';
export default ChairLamp;
